import { render, staticRenderFns } from "./kv-editor.vue?vue&type=template&id=45423368"
import script from "./kv-editor.vue?vue&type=script&lang=js"
export * from "./kv-editor.vue?vue&type=script&lang=js"
import style0 from "./kv-editor.vue?vue&type=style&index=0&id=45423368&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports